/* RESPONSIBLE TEAM: team-ai-agent */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/-private/transition';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeIssuesRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare permissionsService: $TSFixMe;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.issues',
  };

  reactEnabled() {
    return true;
  }

  async beforeModel(transition: Transition) {
    if (!this.appService.app.canSeeIncidentDetection) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.performance');
      return;
    }

    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeIssuesRoute, {
  overrideRenderTemplate: false,
});
